import styled from 'styled-components';
import { MultiFilterSelect } from 'ui/selects';
import { colors, heading4, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

const customSpacing = {
  p350: pxToRem(350),
};

export const BreakdownHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: ${colors.textPrimary};
  padding: ${spacing.base};
`;

export const BreakdownHeaderTitle = styled.div`
  ${heading4};
`;

export const BreakdownHeaderMetricsSection = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.base};
`;

export const StyledMultiSelect = styled(MultiFilterSelect)`
  width: ${customSpacing.p350};
`;

export const CardWrapper = styled.div`
  width: 100%;
  overflow: auto;
  [data-test='table-header-row'] > div:first-child,
  [data-test='table-row'] > div:first-child {
    position: sticky;
    z-index: 2;
    left: 0;
    background: inherit;
    box-shadow: inset -${spacing.quarter} ${spacing.single} ${spacing.half} -${spacing.threeEights}
      rgba(0, 0, 0, 0.16);
  }
`;
